module.exports = __webpack_public_path__ + "static/assets/306095038e9c59412afc01c9a9ee63db.gif";